import { lazy } from "react";

import AppIcons from "../../components/Base/AppIcons";
import PinesCeaOlimpia from "./PinesCeaOlimpia";

const ViewAnulacion = lazy(() => import("./ModuleAnulacion/views/ViewAnulacion"));
const viewRecaudo = lazy(() => import("./ModuleRecaudo/views/ViewRecaudo"));


export const listaPermisosPinesCeaOlimpia = [915, 916]

const rutasPinesCEAOlimpia = {
  link: "/Pines/PinesCeaOlimpia",
  label: <AppIcons Logo={"PINES_GENERACION_LICENCIA"} name="Pines CEA Olimpia" />,
  component: PinesCeaOlimpia,
  permission: [915, 916],
  subRoutes: [
    {
      link: "/Pines/PinesCeaOlimpia/recaudo",
      label: <AppIcons Logo={"PINES_CREAR"} name={"Venta Pines CEA Olimpia"} />,
      component: viewRecaudo,
      permission: [915],
    },
    {
      link: "/Pines/PinesCeaOlimpia/anulacion",
      label: <AppIcons Logo={"PINES_TRAMITAR"} name={"Anulación Pines CEA Olimpia"} />,
      component: ViewAnulacion,
      permission: [916],
    }
  ],
  show: true,
};

export default rutasPinesCEAOlimpia;
